import React from 'react';
import { Box, useMediaQuery } from '@mui/material';

const HelpCenterPublic = () => {
  const isLargeScreen = useMediaQuery('(min-width:960px)');

  return (
    <Box style={{ width: '100%', height: '100%', overflow: 'clip' }}>
      <iframe
        src={`${process.env.PUBLIC_URL}/new_help_center`}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          paddingBottom: isLargeScreen ? 0 : 'calc(50px + var(--bottom-padding, 0))'
        }}
        title="Help Center"
      />
    </Box>
  );
};

export default HelpCenterPublic;
